import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=393091f3&scoped=true"
import script from "./Show.vue?vue&type=script&setup=true&lang=js"
export * from "./Show.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Show.vue?vue&type=style&index=0&id=393091f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393091f3",
  null
  
)

export default component.exports